import React from "react";
import { Button } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

export default function renderTableExpandIcon({
  expanded,
  expandable,
  onExpand,
  record,
}) {
  if (!expandable) return null;

  return (
    <Button
      className="table-details-toggle"
      aria-expanded={expanded}
      icon={expanded ? <UpOutlined /> : <DownOutlined />}
      onClick={(event) => {
        event.stopPropagation();
        onExpand(record, event);
      }}
    >
      {expanded ? "Hide details" : "Show details"}
    </Button>
  );
}
